export class AccessControl {
  canCreate!: boolean
  canDelete!:boolean
  canEdit!:boolean
  canRead!: boolean
  canDownload!: boolean
  canPrint!: boolean
  canSave!: boolean
}
